import { useState } from 'react';

/**
 * ローディング表示の状態管理用カスタムフック
 */
export const useStateAsyncProcess = () => {
	const [isAsyncProcess, setIsAsyncProcess] = useState(false); // ローディング表示の状態管理

	return {
		isAsyncProcess,
		setIsAsyncProcess,
	};
};
